// components/CountdownDisplay.js or .tsx
import React from "react";
import { useCountdown } from "../../../../hooks/useCountDown";

const CountdownDisplay = ({ startTime, messageWhenDone }) => {
  const timeLeft = useCountdown(startTime);

  return (
    <>
      {timeLeft === "Time reached!" ? (
        <span style={{ color: "green" }}>{messageWhenDone}</span>
      ) : (
        <span style={{ color: "red" }}>{timeLeft}</span>
      )}
    </>
  );
};

export default CountdownDisplay;
